/* istanbul ignore file */
import Badge from '../../mui-builder/Badge/Badge';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const NewBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="primary" {...props}>
      New
    </Badge>
  );
};

export default NewBadge;
